// src/locales/frDict.js
// Direct mapping from exact English text strings to French translations.

export const frTranslations = {
  // Navigation & Landing & Header & Footer
  "Autochek Tech Support": "Assistance technique Autochek",
  "Staff portal": "Portail du personnel",
  "Welcome back to our workspace": "Bienvenue dans notre espace de travail",
  "Raise a request, report an incident, or get access to the tools you need — all in one place": "Créez une demande, signalez un incident ou accédez aux outils dont vous avez besoin — le tout en un seul endroit",
  "~2h response time": "~2h de delai",
  "Secure staff access": "Accès sécurisé du personnel",
  "© 2026 Autochek Tech. All rights reserved": "© 2026 Autochek Tech. Tous droits réservés.",
  "Login": "Se connecter",
  "Enter your credentials to access the staff portal": "Saisissez vos identifiants pour accéder au portail du personnel",
  "your.name@autochek.africa": "votre.nom@autochek.africa",
  "Don't have an account? Sign up": "Vous n'avez pas encore de compte ? Inscrivez-vous",
  "Welcome back": "Bienvenue",
  "Autochek Internal Portal": "Portail interne Autochek",
  "Hi": "Bonjour",
  "how can we help you today": "en quoi pouvons-nous vous aider aujourd'hui ?",
  "How can we help you today?": "En quoi pouvons-nous vous aider aujourd'hui ?",
  "How can we": "En quoi pouvons-nous",
  "help you today?": "vous aider aujourd'hui ?",
  "Choose the option that best describes you to get started.": "Choisissez l'option qui vous décrit le mieux pour commencer.",
  "Customer": "Client",
  "Staff": "Personnel",
  "Submit a support request, report an issue, or get help with your vehicle or loan.": "Soumettez une demande d'assistance, signalez un problème ou obtenez de l'aide concernant votre véhicule ou votre prêt.",
  "Raise an internal request, report a production bug, or log a system incident.": "Formulez une demande interne, signalez un bug en production ou enregistrez un incident système.",
  "Support Portal": "Portail d'assistance",
  "Internal Portal": "Portail Interne",
  "Internal Support": "Assistance Interne",
  "General Request": "Demande Générale",
  "Help Center": "Centre d'aide",
  "Secure Staff access": "Accès réservé au personnel",
  "Logout": "Se déconnecter",
  "Contact us about": "Contactez-nous pour",
  "Open request": "Ouvrir la demande",

  // Cards
  "AFS & Loans": "AFS et prêts",
  "Submit an AFS incident or raise a loan-related concern": "Signaler un incident AFS ou faire part d'un problème lié à un prêt",
  "Submit an AFS incident or raise a loan-related concern.": "Signaler un incident AFS ou faire part d'un problème lié à un prêt.",
  "System Issues": "Problèmes système",
  "Report a production bug or log a system incident": "signalez un bug en production ou enregistrez un incident système.",
  "Report a production bug or log a system incident.": "signalez un bug en production ou enregistrez un incident système.",
  "Customer Experience": "Expérience client",
  "Submit a report or complaint on behalf of a customer": "Envoyer un rapport ou une réclamation au nom d'un client.",
  "Submit a report or complaint on behalf of a customer.": "Envoyer un rapport ou une réclamation au nom d'un client.",
  "Access Request": "Demande d'accès",
  "Request access to any of our systems, mailing lists and other resources": "Demandez l'accès à nos systèmes, listes de diffusion et autres ressources.",
  "Request access to any of our systems, mailing lists and other resources.": "Demandez l'accès à nos systèmes, listes de diffusion et autres ressources.",
  "Platform Request": "Requête de plateforme",
  "Request a new installation, application, or service": "Demandez une nouvelle installation, une nouvelle application ou un nouveau service.",
  "Request a new installation, application, or service.": "Demandez une nouvelle installation, une nouvelle application ou un nouveau service.",
  "General": "Général",
  "Submit a suggestion or ask a question to the team": "Envoyez une suggestion ou posez une question à l'équipe.",
  "Submit a suggestion or ask a question to the team.": "Envoyer une suggestion ou poser une question à l'équipe.",

  // Form Sections & Labels - AFS & Loans
  "Contact info": "Coordonnées",
  "Personal details": "Données personnelles",
  "Incident details": "Détails de l'incident",
  "Products and IDs": "Produit et identifiants",
  "Attachments": "Pièces jointes",
  "Relevant files & logs": "Fichiers et logs pertinents",
  "Relevant files": "Fichiers pertinents",
  "Help Center > AFS and loans": "Centre d'aide > AFS et prêts",
  "1. Contact Information": "1. Coordonnées",
  "Contact Information": "Coordonnées",
  "Contact Name": "Nom du contact",
  "Email Address": "Adresse e-mail",
  "Phone Number": "Numéro de téléphone",
  "Country": "Pays",
  "2. Incident Details": "2. Détails de l'incident",
  "Incident Details": "Détails de l'incident",
  "Summary": "Résumé",
  "Product": "Produit",
  "Platform": "Plateforme",
  "Loan ID": "Numéro de prêt",
  "Car ID": "Identifiant du véhicule",
  "Dealer ID": "Identifiant du concessionnaire",
  "Description": "Description",
  "3. Attachments": "3. Pièces jointes",
  "4. Attachments": "4. Pièces jointes",
  "5. Attachments": "5. Pièces jointes",
  "Attachment(s)": "Pièce(s) jointe(s)",
  "Drop files here or click to browse": "Déposez vos fichiers ici ou cliquez pour parcourir",
  "PNG, JPG, PDF up to 10 MB": "PNG, JPG, PDF (jusqu'à 10 Mo)",
  "Your submission is secure and goes directly to the Tech Support Team": "Votre demande est sécurisée et est transmise directement à l'équipe d'assistance technique",
  "Your submission goes securely to Autochek's Customer Experience Team.": "Votre demande est transmise en toute sécurité à l'équipe d'expérience client d'Autochek.",
  "Submit incident": "Soumettre l'incident",
  "Incident Submitted": "Incident soumis",
  "Your AFS/Loan incident has been recorded. Our support team will review it and update you shortly.": "Votre incident AFS/Prêt a été enregistré. Notre équipe d'assistance l'examinera et vous tiendra informé sous peu.",
  "Back to Help Center": "Retour au centre d'aide",

  // System Issues
  "Choose the type of system issue you'd like to report.": "Sélectionnez le type de dysfonctionnement du système que vous souhaitez signaler.",
  "Report a Production Bug": "Signaler un bug de production",
  "Report a production bug": "Signaler un bug de production",
  "Something is broken in production and needs engineering attention.": "Il y a un problème en production qui nécessite l'intervention du service technique.",
  "Something is broken in production and needs engineering attention": "Il y a un problème en production qui nécessite l'intervention du service technique.",
  "Log a System Incident": "Enregistrer un incident système",
  "Log a system incident": "Enregistrer un incident système",
  "A service is down or critically degraded and impacting users.": "Un service est hors service ou son niveau de service a considérablement dégradé et affecte les utilisateurs",
  "A service is down or critically degraded and impacting users": "Un service est hors service ou son niveau de service a considérablement dégradé et affecte les utilisateurs",
  "Production Bug": "Bug de production",
  "Report a live production issue for engineering review.": "Signaler un problème lié à la production en direct afin qu'il soit examiné par l'équipe technique.",
  "Reporter info": "Informations sur le reporter",
  "Summary and description": "Résumé et description",
  "Severity and priority": "Sévérité et priorité",
  "Severity and start time": "Sévérité et heure de début",
  "Context": "Contexte",
  "Impact and reproduction": "Impact et reproduction",
  "Help Center > System Issues > Report Bug": "Centre d'aide > Problèmes techniques > Signaler un bug",
  "1. Reporter Context": "1. Contexte du reporter",
  "Reporter Context": "Contexte du reporter",
  "Critical": "Critique",
  "System down": "Système hors service",
  "High": "Élevé",
  "Major impact": "Impact majeure",
  "Medium": "Moyen",
  "Partial impact": "Impact partiel",
  "Low": "Faible",
  "Minor issue": "Problème mineur",
  "Priority": "Priorité",
  "Source of Request": "Origine de la demande",
  "3. Context & Impact": "3. Contexte & impact",
  "Context & Impact": "Contexte & impact",
  "Steps to Reproduce": "Étapes pour reproduire le problème",
  "Email CCs": "(CC) dans les e-mails",
  "Report Bug": "Signaler un bug",
  "Incident Start Time": "Heure de début de l'incident",
  "Workaround Available": "Solution de contournement disponible",
  "Impacted Module(s)": "Module(s) concerné(s)",
  "Log Incident": "Enregistrer un incident",
  "System Incident": "Incident système",
  "Report a live system outage or critical service disruption.": "Signaler une panne du système en direct ou une interruption critique du service.",
  "Bug Report Submitted": "Rapport de bug soumis",
  "Your production bug report has been received. The engineering team will triage it based on severity.": "Votre rapport de bug de production a été reçu. L'équipe technique l'évaluera en fonction de sa sévérité.",
  "Incident Logged": "Incident enregistré",
  "Your system incident has been logged. The on-call team will respond based on the severity level.": "Votre incident système a été enregistré. L'équipe d'astreinte répondra en fonction du niveau de sévérité.",

  // Access Request
  "Manage system access, onboarding, and off-boarding requests.": "Gérer les demandes d'accès au système, d'intégration et de départ.",
  "Reporter Info": "Information sur le correspondant",
  "1. Reporter Information": "1. Informations sur le correspondant",
  "Contact & job role": "Contact & Fonction",
  "Request Details": "Détails de la requête",
  "2. Request Details": "2. Détails de la requête",
  "Type and description": "Type et description",
  "Type & Description": "Type et description",
  "Approval info": "Information sur l’autorisation",
  "3. Managerial Information": "3. Détails du Manager",
  "Manager details": "Détails du Manager",
  "Platforms": "Plateformes",
  "4. Platform & Access": "4. Plateforme et accès",
  "Access and Mailing list": "Accès et liste de diffusion",
  "Access & Mailing lists": "Accès et liste de diffusion",
  "Help Center > Request Access": "Centre d'aide > Demander un accès",
  "E-mail": "Courriel",
  "Job / Role Function": "Poste / Fonction",
  "Access Request Type": "Type de demande d'accès",
  "Line Manager Name": "Nom du supérieur hiérarchique",
  "Line Manager E-mail": "E-mail du supérieur hiérarchique",
  "Alternate E-mail": "Autre Email",
  "Platform(s)": "Plateforme(s)",
  "Access Level": "Niveau d’accès",
  "Mailing List": "Liste de diffusion",
  "Submit the request": "Envoyer la demande",
  "Request Submitted": "Demande soumise",
  "Your access request has been submitted. Your line manager will be notified for approval where required.": "Votre demande d'accès a été soumise. Votre supérieur hiérarchique sera informé pour validation si nécessaire.",

  // Platform Request
  "Basic info": "Informations de base",
  "1. Basic Info": "1. Informations de base",
  "Request details": "Détails de la demande",
  "Environment and category": "Environnement et catégories",
  "Environment & Category": "Environnement et catégories",
  "Help Center > Platform Request": "Centre d'aide > Demande relative à la plateforme",
  "Environment": "Environnement",
  "Category": "Catégorie",
  "Your request will be sent to the Platform team": "Votre demande sera transmise à l'équipe de la plateforme",
  "Your request will be sent to the Platform team.": "Votre demande sera transmise à l'équipe de la plateforme.",
  "Your platform request has been submitted to the platform team.": "Votre demande relative à la plateforme a été transmise à l'équipe de la plateforme.",

  // Customer Experience
  "Submit a report or complaint on behalf of an Autochek customer": "Envoyer un signalement ou une réclamation au nom d'un client d'Autochek",
  "Submit a report or complaint on behalf of an Autochek customer.": "Envoyer un signalement ou une réclamation au nom d'un client d'Autochek.",
  "Customer info": "Informations client",
  "1. Customer Information": "1. Informations client",
  "Their contact details": "Leurs coordonnées",
  "Ticket details": "Details du ticket",
  "Type, reason & description": "Type, raison & description",
  "Kenya specifics": "Données spécifiques au Kenya",
  "3. Kenya Specific Information": "3. Données spécifiques au Kenya",
  "Country required data": "Données requises par pays",
  "Phone": "Telephone",
  "Case Type": "type de cas",

  // General Issues
  "Choose the type of general request you'd like to submit.": "Sélectionnez le type de demande générale que vous souhaitez envoyer.",
  "Submit a Suggestion": "Soumettez une suggestion",
  "Submit a suggestion": "Soumettez une suggestion",
  "Submit your ideas for business or technical improvements.": "Soumettez vos suggestions d'amélioration opérationnelle ou technique.",
  "Submit yours idea for business or technical improvement": "Soumettez vos suggestions d'amélioration opérationnelle ou technique",
  "Ask a Question": "Posez une question",
  "Ask a question": "Posez une question",
  "Ask operational or system-related questions.": "Posez des questions d'ordre operational ou liées au système.",
  "Ask operational or system related questions": "Posez des questions d'ordre opérationnel ou liées au système",
  "Suggestion Details": "Détails de la suggestion",
  "1. Suggestion Details": "1. Détails de la suggestion",
  "Title & Type": "Titre et type",
  "Business Impact": "Impact sur l'activité",
  "2. Impact & Description": "2. Impact & Description",
  "What & Why": "Quoi et pourquoi?",
  "Short Title": "Titre abrégé",
  "Suggestion Type(s)": "Type(s) de suggestion",
  "Impact & Description": "Impact & Description",
  "What’s your suggestion and why?": "Quelle est ta suggestion et pourquoi ?",
  "Submit Suggestion": "Envoyer une suggestion",
  "Suggestion Submitted": "Suggestion soumise",
  "Thank you for your suggestion! Our team will review it and assess its business impact.": "Merci pour votre suggestion ! Notre équipe l'examinera et en évaluera l'impact sur l'activité.",
  "Your Question": "Votre question",
  "1. Your Question": "1. Votre question",
  "Summary & Details": "Résumé et détails",
  "Module & Context": "Module et contexte",
  "2. Contextual Information": "2. Informations contextuelles",
  "Where and Who": "Lieu et personnes concernées",
  "What is your question?": "Quelle est votre question",
  "Tell us more details": "Donnez nous plus de détails",
  "Contextual Information": "Informations contextuelles",
  "Submit a question": "Poser une question",
  "Submit Question": "Poser une question",
  "Question Submitted": "Question soumise",
  "Your question has been received! We will get back to you with an answer as soon as possible.": "Votre question a bien été reçue ! Nous vous répondrons dès que possible.",

  // Dropdown values
  "Nigeria": "Nigeria",
  "Ghana": "Ghana",
  "Kenya": "Kenya",
  "Uganda": "Uganda",
  "Ivory Coast": "Côte d’ivoire",
  "Cote d'Ivoire": "Côte d’ivoire",
  "Senegal": "Sénégal",
  "South Africa": "Afrique du sud",
  "Morocco": "Maroc",
  "Egypt": "Egypte",

  "New Employee Onboarding": "Intégration des nouveaux employés",
  "Off-boarding": "Départ",
  "Current Employee": "actuel Employé",

  "Admin": "Administrateur",
  "Read-only(View)": "Lecture seule (Affichage)",
  "Editor": "Rédacteur",

  "Production": "Production",
  "Staging": "Staging",
  "Development": "Développement",

  "New installation": "Nouvelle installation",
  "New Application": "Nouvelle application",
  "Service": "Service",
  "service": "Service",
  "Emails": "E-mails",
  "Existing service": "Service Existant",

  "Highest": "Très élevé",
  "Lowest": "Très faible",

  "Business Team": "Equipe Commerciale",
  "Technical Team": "Equipe Technique",

  "UI/UX Improvement": "Amélioration de UI/UX",
  "Process Improvement": "Amélioration des processus",
  "Performance Optimization": "Optimisation des performances",
  "Cost Saving Suggestion": "Suggestions de réduction des coûts",
  "Customer Experience Idea": "Idées pour améliorer l'expérience client",
  "Minor Change Request": "Demande de modification mineure",
  "Documentation": "Documentation",
  "Other": "Autre",

  "No": "Non",
  "Yes": "Oui",
  "Partial": "Partiel",

  "AMC Issue": "Problème lié à l'AMC",
  "Application Issue": "Problème lié à la demande",
  "Service Centre Issue": "Problème lié au centre de service",
  "Product Knowledge Issue": "Problème lié à la connaissance du produit",
  "Rude Staff": "Personnel indiscipliné",
  "Faulty Vehicle": "Véhicule défectueux",
  "Car Delivery Issue": "Problème lié à la livraison du véhicule",
  "Wrong Transaction": "Transaction erronée",
  "Repayment not updated": "Remboursement non mis à jour",
  "Car Documents": "Documents du véhicule",
  "Liquidation Issue": "Problème lié à la liquidation",
  "Loan Restructuring Issue": "Problème lié à la restructuration du prêt",
  "Dealer Management": "Gestion du concessionnaire",
  "Vehicle Repossession": "Saisie du véhicule",
  "Wrong Plate Number": "Numéro d'immatriculation erroné",
  "Loan Repayment Issue": "Problème lié au remboursement du prêt",
  "Plate Number issue": "Problème lié au numéro d'immatriculation",
  "CAC Document Issue": "Problème lié aux documents CAC",
  "Bank- Faulty Vehicle": "Banque – Véhicule défectueux",
  "Bank- Document Issue": "Banque – Problème lié aux documents",
  "Bank- Vehicel Maintenance Issue": "Banque – Problème d'entretien du véhicule",
  "Bank- PFI Issue": "Banque – Problème lié au PFI",
  "Account Statement Issue": "Problème lié au relevé de compte",
  "Final Message for Repossession": "Message final concernant la reprise de possession",

  "Application Declined": "Demande refusée",
  "Car Delivery": "Livraison de voiture",
  "Car Purchase": "Achat de voiture",
  "Cash Loan": "Prêt en espèces",
  "Change Mind": "Changement d'avis",
  "Equity Release": "Libération de capital immobilier",
  "Financing Repayments": "Remboursements de prêt",
  "Payment Confirmation": "Confirmation de paiement",
  "Car Sales": "Vente de voitures",
  "Vehicle Documents": "Documents du véhicule",
  "Service Center": "Centre de service",
  "Insurance": "Assurance",
  "EQ-Car Swap Services": "Services d'échange de voitures EQ",
  "EQ-Car Rental Services": "Services de location de voitures EQ",
  "RQ- AMC": "RQ-AMC",
  "RQ- Car Documents": "RQ-Documents du véhicule",
  "RQ- Re-Apply": "RQ - Nouvelle demande",
  "RQ- Repayment Liquidation": "RQ - Liquidation de remboursement",
  "RQ- Repayment Reconciliation": "RQ - Rapprochement de remboursement",
  "RQ- Insurance Claim": "RQ - Demande d'indemnisation",
  "RQ- Credit Report": "RQ - Rapport de solvabilité",
  "RQ- Statement of account": "RQ - Relevé de compte",
  "RQ- Car Repairs": "RQ - Réparations automobiles",
  "RQ- Loan Cancellation Request": "RQ - Demande d'annulation de prêt",
  "RQ- Service Center": "RQ - Centre de service",
  "RQ- LONI": "RQ - LONI",
  "RQ- Cash Loan Top-up": "RQ - Augmentation du montant du prêt en espèces",
  "RQ-Repayment Date Extension": "RQ - Prolongation de la date de remboursement",
  "RQ- Tracker Access": "RQ - Accès au suivi",
  "Warranty Claim": "Demande de garantie",
  "RQ - Spare Key": "RQ - Clé de rechange",
  "RQ - Reposession Relief Appeal": "RQ - Recours contre la saisie",
  "RQ - Security Deposit": "RQ - Dépôt de garantie",
  "Car Valuation": "Estimation du véhicule",
  "Office Location": "Adresse du bureau",
  "Feedback": "Commentaires",
  "Internal Communications": "Communications internes",
  "VAP Campaign": "Campagne VAP",
  "VAP- Tyre Purchase": "VAP - Achat de pneus",
  "VAP- Document Renewal": "VAP - Renouvellement de documents",
  "Customer Onboarding": "Intégration des clients",
  "Credit Life Insurance": "Assurance vie crédit",
  "Others": "Autres",

  "Legal Case": "Dossier juridique",
  "Sponsorship and Partnership": "Parrainage et partenariat",
  "Job Application": "Candidature à un poste",
  "Dropped Calls": "Appels interrompus",
  "Transferred to Collections Team": "Transfert vers l'équipe de recouvrement",
  "Voluntary Surrender": "Remise volontaire",
  "Dropped Chat": "Discussion en ligne interrompue",
  "Survey Calls": "Appels d'enquête",

  // Misc & Toast
  "Ticket submitted successfully!": "Ticket soumis avec succès !",
  "Support ticket submitted successfully!": "Ticket d'assistance soumis avec succès !",
  "Submit Request": "Envoyer la demande",
  "Submit Ticket": "Envoyer le ticket",
  "Submitting…": "Envoi en cours…",
  "Back to Dashboard": "Retour au tableau de bord",
  "Back to General": "Retour à Général",
  "Attached files:": "Fichiers joints :"
};
